// Apple Pay nur auf Apple-Geraeten/Safari anbieten (sonst Sackgasse auf Mollies Hosted-Page).
// Google Pay NICHT gaten: kein GPay-SDK in der EUA geladen, GPay laeuft browseruebergreifend,
// Mollies Hosted-Checkout regelt die Button-Verfuegbarkeit selbst.
export function isMethodAvailableOnDevice(methodId: string): boolean {
    if (methodId === "applepay") {
        // canMakePayments() kann in eingeschraenkten Kontexten werfen (z. B. Cross-Origin-
        // iFrame ohne allow="payment" — die EUA laeuft als Web-Modul eingebettet — oder
        // exotische WebKit-WebViews). Defensiv kapseln: im Fehlerfall Apple Pay verstecken
        // (return false), NIEMALS den Render-Flow der Buchungsseite crashen lassen
        // (gleiches Muster wie parentIFrame.ts fuer dieselbe iFrame-Flaeche).
        try {
            const aps = typeof window !== "undefined" ? (window as any).ApplePaySession : undefined
            return !!aps && typeof aps.canMakePayments === "function" && aps.canMakePayments()
        } catch (_err) {
            return false
        }
    }
    return true
}
